import { Outlet, useMatches, useNavigate } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'

import Heading from '~/client/components/Heading'

export default function Layout() {
  const navigate = useNavigate()
  const matches = useMatches()
  console.log({ matches })
  const path = matches.reverse()[0].pathname.replace('/styleguide', '').replace(/(^\/|\/$)/g, '').toLowerCase()
  console.log({ path })
  return <Container>
    <Heading>Styleguide</Heading>
    <Box>
      <Select {...{
        name: 'agreementType',
        labelId: 'AgreementTypeInputLabel',
        value: path,
        onChange(event){
          const path = event.target.value
          navigate(`/styleguide/${path}`)
        }
      }}>
        <MenuItem value="appicon">AppIcon</MenuItem>
        <MenuItem value="button">Button</MenuItem>
        <MenuItem value="typography">Typography</MenuItem>
      </Select>
    </Box>
    <Outlet/>
  </Container>
}
